import React from 'lib/react';
import {
  EVGrid, EVRadio, EVInputLabel, EVReportProblemOutlined,
} from 'lib/components';
import Typography from 'commonComponents/typography';
import { useTranslation, Trans } from 'lib/translation';
import SelectField from 'commonComponents/select-field';
import { useDispatch } from 'lib/redux';
import { MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY, SAVE_SUSPEND_PREPAY_OPTIONS } from 'constants/ActionTypes';
import { useSelector } from 'react-redux';
import Button from 'lib/components/button';

import ManagePaymentOptionsStyles from '../ManagePaymentOptionsStyles';
import {
  getMonthYear, getNextMonthsList,
} from '../ManagePaymentOptions.utils';
import { SUSPEND_OPTIONS, suspendMonthlyPrepaymentOptions } from '../ManagePaymentOptions.constants';

function SuspendPrepay() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = ManagePaymentOptionsStyles();
  const next6MonthsList = getNextMonthsList(6);

  const { suspendMonthlyPrepay, accountSummary, saveloading } = useSelector(({ managePaymentOptions, userData }) => ({
    suspendMonthlyPrepay: managePaymentOptions.suspendMonthlyPrepay,
    saveloading: managePaymentOptions.saveloading,
    accountSummary: userData.accountSummary,
  }));

  const selectedSupendMonthlyPrepayOption = suspendMonthlyPrepay || accountSummary?.suspendMonthlyPrepay;
  const currentMonthYear = getMonthYear(selectedSupendMonthlyPrepayOption?.suspendBillingUntil?.split(' ')[0]);
  const selectedMonth = next6MonthsList.find((month) => month.description === currentMonthYear)?.id;

  const handleSuspendMonthlyPrepaymentChange = (e) => {
    const { target: { id } } = e;
    dispatch({
      type: MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY,
      suspendMonthlyPrepayValues: {
        suspendBilling: Number(id) !== SUSPEND_OPTIONS.NO,
        ...(Number(id) === SUSPEND_OPTIONS.YES_THROUGH_MONTH && {
          suspendBillingUntil: next6MonthsList[selectedMonth]?.dateTime,
        }),
      },
    });
  };

  const isChecked = (id) => {
    if (!selectedSupendMonthlyPrepayOption?.suspendBilling) return id === SUSPEND_OPTIONS.NO;
    return id === (selectedSupendMonthlyPrepayOption?.suspendBillingUntil ? SUSPEND_OPTIONS.YES_THROUGH_MONTH : SUSPEND_OPTIONS.YES_UNTIL_REINSTATE);
  };

  const handleSuspendTillMonth = (e) => {
    const { target: { value } } = e;
    dispatch({
      type: MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY,
      suspendMonthlyPrepayValues: {
        suspendBilling: true,
        suspendBillingUntil: next6MonthsList[value]?.dateTime,
      },
    });
  };
  const handleSave = () => { dispatch({ type: SAVE_SUSPEND_PREPAY_OPTIONS }); };
  return (
    <EVGrid className={classes.prePaymentPaperContent}>
      <Typography variant="h3-600" fontColor="ocean-700">
        {t('manage_payment__suspend_monthly_prepayment')}
      </Typography>
      {suspendMonthlyPrepaymentOptions?.map((option) => (
        // #genai - option id is the stable identity for each suspend option row
        <EVGrid key={`suspendPrepayOptionRow-${option.id}`} container alignItems="center" style={{ gap: 8, width: 'fit-content' }}>
          <EVGrid container alignItems="center" style={{ gap: 16 }}>
            <EVRadio
              id={option.id}
              data-testid={`radio-testid-${option.id}`}
              color="primary"
              key={`suspendPrepayOption-${option.id}`}
              checked={isChecked(Number(option.id))}
              onChange={handleSuspendMonthlyPrepaymentChange}
              style={{ padding: '0px', width: 'fit-content' }}
              name={`suspendPrepayOption-${option.id}`}
            />
            <EVInputLabel htmlFor={option.id} style={{ fontSize: '16px', color: 'black', fontWeight: '400' }}>
              {t(option?.description)}
            </EVInputLabel>
            {option?.id === SUSPEND_OPTIONS.YES_THROUGH_MONTH && (
              <SelectField
                variant="outlined"
                selectId="selectMonth"
                selectedValue={next6MonthsList[selectedMonth]?.id}
                selectOptions={next6MonthsList}
                style={{ height: '44px' }}
                handleChange={handleSuspendTillMonth}
              />
            )}
          </EVGrid>
          {option?.id === SUSPEND_OPTIONS.YES_THROUGH_MONTH && isChecked(option?.id) && (
          <EVGrid className={classes.reminderBox}>
            <EVReportProblemOutlined htmlColor="#CC7000" />
            <Typography variant="h4-400" fontColor="charcoal-900">
              <Trans
                i18nKey="manage_payment__reminder"
                values={{
                  suspendedTillMonth: next6MonthsList[selectedMonth]?.description,
                  resumesOnMonth: getNextMonthsList(7)[selectedMonth + 1]?.description,
                }}
              />
            </Typography>
          </EVGrid>
          )}
        </EVGrid>
      ))}
      <Button
        id="save-btn"
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleSave}
        loading={saveloading}
      >
        {t('common__save')}
      </Button>
    </EVGrid>
  );
}

export default SuspendPrepay;
